<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="8" :sm="24">
            <a-form-item label="名称">
              <a-input placeholder="请输入公司机械名称" v-model="queryParam.name"/>
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <a-form-item label="类别">
              <a-input placeholder="请输入机械类别" v-model="queryParam.type"/>
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <a-form-item label="使用状态">
              <a-select v-model="queryParam.state" placeholder="请选择" default-value="0">
                <a-select-option value="0">损坏</a-select-option>
                <a-select-option value="1">正常</a-select-option>
                <a-select-option value="">全部</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="48">
          <a-col :md="8" :sm="24">
            <a-form-item label="项目">
              <a-select
                showSearch
                style="max-width: 200px;min-width: 100%"
                placeholder="请选择"
                v-decorator="['projectId', {rules: [{required: true, message: '请选择项目'}]}]"
                :options="projectList"
                v-model="queryParam.projectId"
                optionFilterProp="children"
              >
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <a-button @click="() => {this.queryPage()}" type="primary">查询</a-button>
            <a-button @click="() => queryParam = {}" style="margin-left: 8px">重置</a-button>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div class="table-operator">
      <a-button
        @click="$refs.sxCompanyMachineAddOrUpdate.init('','add')"
        icon="plus"
        type="primary"
        v-action="'purchase:machine-form:add'"
      >新建</a-button>
    </div>
    <s-table
      bordered
      ref="table"
      :data="loadData"
      :columns="columns"
      :rowKey="record => record.id"
    >
    </s-table>
    <sxCompanyMachine-add-or-update
      @ok="queryPage"
      ref="sxCompanyMachineAddOrUpdate"
    />
    <cost-apportion
      ref="costApportion"
    />
  </a-card>
</template>

<script>
import { TableMixin } from '@/mixins/TableMixin'
import { fetchList, damObj } from '@/api/common/SxCompanyMachine'
import { dropProjectList } from '@/api/project/ProjectInfo'
import sxCompanyMachineAddOrUpdate from './SxCompanyMachineAddOrUpdate'
import costApportion from './CostApportion'
import { enterEvent } from '@/utils/util'
import ARow from 'ant-design-vue/es/grid/Row'
const stateList = [
  {
    label: '损坏',
    status: 'error',
    value: '0'
  },
  {
    label: '正常',
    status: 'success',
    value: '1'
  }
]

export default {
  name: 'SxCompanyMachineView',
  mixins: [TableMixin],
  components: {
    ARow,
    sxCompanyMachineAddOrUpdate,
    costApportion
  },
  data () {
    return {
      description: '对公司机械进行维护和调度',
      projectList: [],
      queryParam: {
        test: '',
        type: '',
        projectId: undefined,
        state: '1'
      },
      loadData: parameter => {
        return fetchList(
          Object.assign(parameter, this.queryParam)
        ).then(res => {
          return res.data
        })
      },
      columns: [
        {
          title: '序号',
          width: '62px',
          customRender: (text, record, index) => {
            return (
              <div>
                {index + 1}
              </div>
            )
          }
        },
        // {
        //   title: '主键',
        //   dataIndex: 'id'
        // },
        {
          title: '机械名称',
          dataIndex: 'name'
        },
        {
          title: '工日单价(元)',
          width: '120px',
          dataIndex: 'unitPrice',
          customRender: (text) => {
            return (
              <div style="float:right">
                { text === null ? ' - ' : Number(text).toFixed(2)}
              </div>
            )
          }
        },
        // title: '机械类别（手填）',
        {
          title: '所在项目',
          dataIndex: 'projectIdName'
        },
        {
          title: '机械类别',
          dataIndex: 'type'
        },
        {
          title: '状态',
          dataIndex: 'state',
          customRender: (record) => {
            return (
              <div>
                {
                  stateList.map(item => {
                    if (item.value === record) {
                      return <a-badge status={item.status} text={item.label}/>
                    }
                  })
                }
              </div>
            )
          }
        },

        {
          title: '操作',
          align: 'center',
          width: '270px',
          customRender: (record) => {
            return (
              <div>
                <span v-action="purchase:machine-form:show">
                  <a onClick={(e) => this.show(record)}>查看</a>
                </span>
                <span v-action="purchase:machine-form:edit">
                  <a-divider type="vertical" />
                  <a onClick={(e) => this.edit(record)}>修改</a>
                </span>
                <span v-action="purchase:machine-form:dam">
                  <a-divider type="vertical" />
                  <a-popconfirm title="是否进行报损" onConfirm={() => this.dam(record)} okText="是" cancelText="否">
                    <a-icon slot="icon" type="question-circle-o" style="color: red" />
                    <a href="javascript:;" style="color: red">报损</a>
                  </a-popconfirm>
                </span>
                <span v-action="purchase:machine-form:distract">
                  <a-divider type="vertical" />
                  <a-tooltip title="修改该机械在哪个项目下">
                    <a onClick={(e) => this.distract(record)}>转移</a>
                  </a-tooltip>
                </span>
                <span v-action="purchase:machine-form:apportion">
                  <a-divider type="vertical" />
                  <a-tooltip title="记录机械在每个项目下的时间，用来计算费用" placement="topRight">
                    <a onClick={(e) => this.apportion(record)}>费用分摊</a>
                  </a-tooltip>
                </span>
              </div>
            )
          }
        }
      ]
    }
  },
  methods: {
    show (record) {
      this.$refs.sxCompanyMachineAddOrUpdate.init(record.id, 'show')
    },
    edit (record) {
      this.$refs.sxCompanyMachineAddOrUpdate.init(record.id, 'edit')
    },
    dam (record) {
      damObj(record.id).then(res => {
        this.$message.info('报损成功')
        this.queryPage()
      })
    },
    distract (record) {
      this.$refs.sxCompanyMachineAddOrUpdate.init(record.id, 'distract')
    },
    apportion (record) {
      this.$refs.costApportion.init(record.id)
    }
  },
  created () {
    dropProjectList().then(res => {
      this.projectList = res.data
    })
    enterEvent(this.queryPage)
  }
}
</script>

<style scoped>

</style>
